import { isEmpty } from 'lodash';
import { Icon } from '@wordpress/icons';
import parse from 'html-react-parser';
import blockIcon from './../icons/block-icon';
import { DEFAULT_ICON_WIDTH } from '@constants';

const {
  i18n: { __ },
  element: { useEffect, useState },
  components: { Button, Modal, TextareaControl, Notice },
} = wp;

const CodeInserterModal = (props) => {
  const { setCodeInserterOpen, attributes, setAttributes } = props;
  const { icon, iconName } = attributes;

  const [customIcon, setCustomIcon] = useState(!iconName ? icon : '');
  useEffect(() => setCustomIcon(icon), [icon]);

  const insertCustomIcon = () => {
    setAttributes({
      icon: customIcon,
      iconName: '',
      iconExtension: '',
    });
    setCodeInserterOpen(false);
  };

  let iconToRender = parse(customIcon);
  const validSVG =
    !isEmpty(iconToRender?.props) &&
    iconToRender?.type &&
    iconToRender.type === 'svg';
  iconToRender =
    iconToRender && customIcon && validSVG ? iconToRender : blockIcon;

  return (
    <Modal
      className="code-inserter__modal"
      title={__('Custom Icon', 'b3rg')}
      onRequestClose={() => setCodeInserterOpen(false)}
      isFullScreen
    >
      <div className="code-inserter">
        <div className="code-inserter__content">
          <TextareaControl
            label={__('Custom icon', 'b3rg')}
            value={customIcon}
            onChange={(iconCode) => {
              const iconToRender = parse(iconCode);
              const { props } = iconToRender;
              const width = props?.width || DEFAULT_ICON_WIDTH;
              if (width) {
                setAttributes({ width });
              }
              setCustomIcon(iconCode.trim());
            }}
            placeholder={__('Paste the SVG code for your custom icon.', 'b3rg')}
          />
        </div>
        <div className="code-inserter__sidebar">
          <div className="icon-preview">
            <Icon icon={iconToRender} size={300} />
            {customIcon && !validSVG && (
              <Notice status="error" isDismissible={false}>
                {__(
                  'The custom icon does not appear to be in a valid SVG format or contains non-SVG elements.',
                  'b3rg',
                )}
              </Notice>
            )}
          </div>
          <div className="icon-insert-buttons">
            <Button
              label={__('Clear custom icon', 'b3rg')}
              isSecondary
              disabled={!customIcon}
              onClick={() => setCustomIcon('')}
            >
              {__('Clear', 'b3rg')}
            </Button>
            <Button
              label={__('Insert custom icon', 'b3rg')}
              isPrimary
              disabled={!validSVG || !customIcon}
              onClick={insertCustomIcon}
            >
              {__('Insert custom icon', 'b3rg')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CodeInserterModal;
